<template>
  <div style="height: 100%">
    <div class="background" :style="sectionBackgroundStyle">
      <div class="overlay"></div>
    </div>
    <div
      style="height: 100%"
      class="d-flex flex-column justify-center align-center"
    >
      <v-card
        style="min-width: 30%"
        class="
          d-flex
          flex-column
          justify-center
          align-center
          pa-6
          py-10
          mx-2
          my-4
        "
        elevation="0"
      >
        <img :src="logoUrl" style="width: 150px" />
        <h1 class="headline text-center mt-4">Reset Password</h1>
        <div v-if="submitSuccess" class="d-flex flex-column justify-center">
          <p class="subtitle-1 text-center mt-4 mb-2">
            Your password has been updated.
          </p>
          <v-btn color="primary" small rounded depressed @click="redirectLogin"
            >Login Here To Continue</v-btn
          >
        </div>
        <div v-if="!user" class="d-flex flex-column justify-center pa-6">
          <p class="subtitle-1 text-center">
            The link you provided is no longer valid
          </p>
          <v-btn color="primary" block rounded depressed @click="redirectLogin"
            >Login Here</v-btn
          >
        </div>
        <v-form
          v-if="!submitSuccess && user"
          ref="form"
          v-model="formValid"
          style="width: 100%"
          lazy-validation
        >
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="pb-0">
                <v-text-field
                  v-model="newPass"
                  style="min-width: 275px"
                  label="Enter your new password"
                  :rules="passwordRules"
                  :type="passwordType"
                  required
                  background-color="grey lighten-3"
                  solo
                  dense
                  flat
                >
                  <template v-slot:prepend-inner>
                    <v-icon small>mdi-lock</v-icon>
                  </template>
                  <template v-slot:append>
                    <v-btn
                      v-if="passwordType === 'password'"
                      small
                      icon
                      @click="showPassword"
                      ><v-icon small>mdi-eye</v-icon></v-btn
                    >
                    <v-btn
                      v-if="passwordType === 'text'"
                      small
                      icon
                      @click="hidePassword"
                      ><v-icon small>mdi-eye-off</v-icon></v-btn
                    >
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-text-field
                  v-model="confirmPass"
                  style="min-width: 275px"
                  label="Confirm Password"
                  :rules="passwordRulesConfirm"
                  :type="passwordTypeConfirm"
                  required
                  background-color="grey lighten-3"
                  solo
                  dense
                  flat
                >
                  <template v-slot:prepend-inner>
                    <v-icon small>mdi-lock</v-icon>
                  </template>
                  <template v-slot:append>
                    <v-btn
                      v-if="passwordTypeConfirm === 'password'"
                      small
                      icon
                      @click="showPasswordConfirm"
                      ><v-icon small>mdi-eye</v-icon></v-btn
                    >
                    <v-btn
                      v-if="passwordTypeConfirm === 'text'"
                      small
                      icon
                      @click="hidePasswordConfirm"
                      ><v-icon small>mdi-eye-off</v-icon></v-btn
                    >
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-card-actions v-if="!submitSuccess && user">
          <v-btn
            color="primary darken-1"
            text
            :disabled="!formValid || newPass != confirmPass || newPass === ''"
            @click="submit"
            >Submit</v-btn
          >
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar">
      {{ snackMessage }}
      <v-btn color="primary" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { BASE_URL } from '../../src/config/env'
export default {
  props: ['code'],
  data() {
    return {
      newPass: '',
      confirmPass: '',
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => {
          const pattern = /(?=.*\d)(?=.*[A-Za-z])/
          return (
            pattern.test(v) ||
            'Password must contain at least one number and letter'
          )
        },
        (v) => v.length >= 8 || 'Password must contain at least 8 characters'
      ],
      passwordRulesConfirm: [
        (v) => !!v || 'Please retype your password',
        (v) => v == this.newPass || 'Password does not match'
      ],
      sectionBackgroundStyle: `background-image: url(${BASE_URL}images/cover_img_1.jpg); background-size:cover; background-position: center center;background-attachment:fixed;`,
      user: null,
      submitSuccess: false,
      loading: false,
      formValid: true,
      snackbar: false,
      snackMessage: '',
      passwordType: 'password',
      passwordTypeConfirm: 'password'
    }
  },
  computed: {
    logoUrl() {
      return `${process.env.BASE_URL}images/logo_text_bottom.png`
    }
  },
  async created() {
    this.user = await this.$store.dispatch(
      'users/fetchPasswordResetUserAction',
      { code: this.code }
    )
  },
  methods: {
    async submit() {
      this.loading = true
      try {
        await this.$store.dispatch('users/resetPasswordAction', {
          userId: this.user.userId,
          forgotPassword: this.code,
          newPass: this.newPass
        })
        this.submitSuccess = true
        this.loading = false
      } catch (err) {
        this.snackMessage = err
        this.snackbar = true
        this.submitSuccess = false
        this.loading = false
      }
    },
    cancel() {
      this.$router.replace('/login')
    },
    redirectLogin() {
      this.$router.replace('/login')
    },
    showPassword() {
      this.passwordType = 'text'
    },
    hidePassword() {
      this.passwordType = 'password'
    },
    showPasswordConfirm() {
      this.passwordTypeConfirm = 'text'
    },
    hidePasswordConfirm() {
      this.passwordTypeConfirm = 'password'
    }
  }
}
</script>

<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60%;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  height: 100%;
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #662d91),
    color-stop(100%, #798eea)
  );
  background: -webkit-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -ms-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: linear-gradient(135deg, #662d91 0%, #798eea 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#662d91', endColorstr='#798eea', GradientType=1 );
}
.v-card {
  border-radius: 12px !important;
}
</style>
